import { AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { fmtR } from './constants';

/** Incidents-by-driver leaderboard table shown at the bottom of Reports. */
export const IncidentsByDriverCard = ({ incidentReport, monthLabel }) => {
  if (!incidentReport || !incidentReport.total_incidents) return null;
  return (
    <Card data-testid="incidents-by-driver-card">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg font-heading font-semibold flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-red-600" />
            Incidents by Driver — {monthLabel}
          </CardTitle>
          <span className="text-xs font-mono uppercase tracking-wider text-gray-500">
            {incidentReport.total_incidents} total incident{incidentReport.total_incidents !== 1 ? 's' : ''}
          </span>
        </div>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b-2 border-slate-900">
                <th className="text-left py-2 px-4 text-xs font-mono uppercase tracking-wider text-slate-500">Driver</th>
                <th className="text-right py-2 px-4 text-xs font-mono uppercase tracking-wider text-slate-500">Incidents</th>
                <th className="text-left py-2 px-4 text-xs font-mono uppercase tracking-wider text-slate-500">Top Types</th>
                <th className="text-right py-2 px-4 text-xs font-mono uppercase tracking-wider text-slate-500">Damage (R)</th>
                <th className="text-right py-2 px-4 text-xs font-mono uppercase tracking-wider text-slate-500">Last Incident</th>
              </tr>
            </thead>
            <tbody>
              {incidentReport.by_driver.map((d) => {
                const topTypes = Object.entries(d.by_type || {})
                  .sort((a, b) => b[1] - a[1])
                  .slice(0, 3)
                  .map(([t, c]) => `${t}×${c}`).join(', ');
                return (
                  <tr key={d.driver_id} className="border-b border-slate-100 hover:bg-slate-50 transition-colors" data-testid={`report-incidents-driver-${d.driver_id}`}>
                    <td className="py-3 px-4">
                      <p className="font-medium text-slate-900">{d.driver_name}</p>
                    </td>
                    <td className={`py-3 px-4 text-right font-data font-bold text-lg ${d.total > 2 ? 'text-red-600' : 'text-amber-600'}`}>
                      {d.total}
                    </td>
                    <td className="py-3 px-4 text-sm text-slate-600 font-mono">{topTypes || '—'}</td>
                    <td className="py-3 px-4 text-right font-data text-slate-700">{fmtR(d.damage_total)}</td>
                    <td className="py-3 px-4 text-right font-data text-slate-500 text-sm">{d.last_incident || '—'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};
